export * from './icon-config';
export * from './icon.component';
export * from './icon.module';
export * from './icon.service';
